import React, { useEffect, useState, useRef } from "react";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { Circles } from "react-loader-spinner";
import Swal from "sweetalert2";
import Moment from "moment";
import "moment/locale/es";

import { Card, CardBody } from "./../../components/card/card.jsx";
import {
  BarraFiltrosSolicitudes,
  consultarSolicitudes,
  crearFiltrosIniciales,
  useOpcionesFiltros,
} from "./../../components/filtros-solicitudes/filtros-solicitudes.jsx";

import "bootstrap-daterangepicker/daterangepicker.css";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
import "datatables.net-responsive-bs5/css/responsive.bootstrap5.min.css";
import "datatables.net-fixedcolumns-bs5/css/fixedColumns.bootstrap5.min.css";
import "datatables.net-buttons-bs5/css/buttons.bootstrap5.min.css";

const $ = require("jquery");
$.DataTable = require("datatables.net");
require("datatables.net-bs5");
require("datatables.net-buttons");
require("datatables.net-buttons/js/buttons.colVis.min.js");
require("datatables.net-buttons/js/buttons.html5.min.js");
require("datatables.net-buttons/js/buttons.print.min.js");
require("datatables.net-buttons-bs5");
require("datatables.net-responsive");
require("datatables.net-responsive-bs5");
require("datatables.net-fixedcolumns");
require("datatables.net-fixedcolumns-bs5");

Moment.locale("es");

const Rendimiento = () => {
  const [mailData, setMailData] = useState([]);
  const [processedData, setProcessedData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [topCinco, setTopCinco] = useState([]);

  const tableRef = useRef(null);

  // Filtros homologados (últimos 60 días por default)
  const [filters, setFilters] = useState(crearFiltrosIniciales);
  const { opciones: opcionesFiltros } = useOpcionesFiltros(mailData);

  const accessToken =
    "1MhYphhrGUbgbdRy7cyYFGQlXS7tAi6ooUoptkHQbOm9GcsKiZM7uMF1MERxwMWq30I7Y3";

  const apiUrl = "https://api.checkmark.mx/solicitudes/consultar";

  const normalizarTexto = (valor) => {
    return String(valor || "")
      .trim()
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");
  };

  const esCreditoSolicitud = (solicitud) => {
    const dependeAuto = normalizarTexto(
      solicitud.depende_auto ?? solicitud.depente_auto,
    );

    // Regla actual:
    // depende_auto = "No" => Crédito
    // depende_auto = "Si" => Contado
    return dependeAuto === "no";
  };

  const esContadoSolicitud = (solicitud) => {
    const dependeAuto = normalizarTexto(
      solicitud.depende_auto ?? solicitud.depente_auto,
    );

    return dependeAuto === "si";
  };

  const esArrendamientoSolicitud = (solicitud) => {
    const dependeAuto = normalizarTexto(
      solicitud.depende_auto ?? solicitud.depente_auto,
    );

    return dependeAuto === "arrendamiento";
  };

  const obtenerProductos = (cliente) => {
    let productos = [];

    if (cliente.plan_accesorios) {
      try {
        const accesorio = JSON.parse(cliente.plan_accesorios);
        productos = Array.isArray(accesorio) ? accesorio : [accesorio];
      } catch (error) {
        console.error(
          `Error al parsear plan_accesorios para el cliente con ID ${cliente.id}:`,
          error,
        );
      }
    }

    return productos;
  };

  const generarRendimientoPorAsesor = (resultados) => {
    const agrupados = resultados.reduce((acc, solicitud) => {
      const asesor =
        (solicitud.asesor ? solicitud.asesor.trim() : "") || "Sin asesor";

      if (!acc[asesor]) {
        acc[asesor] = {
          nombre: asesor,

          total: 0,
          totalCredito: 0,
          totalContado: 0,
          totalArrendamiento: 0,

          // Status crédito
          autorizado: 0,
          rechazadoCredito: 0,
          pendienteBuro: 0,

          // Substatus crédito
          analisis: 0,
          incompleto: 0,
          condicionadoViable: 0,
          condicionadoNoViable: 0,
          facturado: 0,
          formalizadoCredito: 0,
          aprobadoSinFormalizar: 0,
          rechazadoSubstatus: 0,

          // Status contado
          cotizacionContado: 0,
          formalizadoContado: 0,

          // Status arrendamiento
          cotizacionArrendamiento: 0,
          pendienteAutorizacionArrendamiento: 0,
          autorizadoArrendamiento: 0,
          rechazadoArrendamiento: 0,
          formalizadoArrendamiento: 0,

          // Totales combinados útiles
          formalizadosTotal: 0,
          rechazadosTotal: 0,

          telefono: solicitud.asesor_telefono || "Sin teléfono",
          correo_electronico: solicitud.asesor_correo || "Sin correo",
        };
      }

      acc[asesor].total += 1;

      const esCredito = esCreditoSolicitud(solicitud);
      const esContado = esContadoSolicitud(solicitud);
      const esArrendamiento = esArrendamientoSolicitud(solicitud);

      const status = normalizarTexto(solicitud.status);
      const subStatus = normalizarTexto(solicitud.sub_status);

      if (esCredito) {
        acc[asesor].totalCredito += 1;

        // Status de crédito
        if (status === "autorizado") {
          acc[asesor].autorizado += 1;
        } else if (status === "rechazado") {
          acc[asesor].rechazadoCredito += 1;
          acc[asesor].rechazadosTotal += 1;
        } else if (status === "pendiente de buro") {
          acc[asesor].pendienteBuro += 1;
        }

        // Substatus de crédito
        if (subStatus === "analisis") {
          acc[asesor].analisis += 1;
        } else if (subStatus === "incompleto") {
          acc[asesor].incompleto += 1;
        } else if (subStatus === "condicionado viable") {
          acc[asesor].condicionadoViable += 1;
        } else if (subStatus === "condicionado no viable") {
          acc[asesor].condicionadoNoViable += 1;
        } else if (subStatus === "facturado") {
          acc[asesor].facturado += 1;
        } else if (subStatus === "formalizado") {
          acc[asesor].formalizadoCredito += 1;
          acc[asesor].formalizadosTotal += 1;
        } else if (subStatus === "aprobado sin formalizar") {
          acc[asesor].aprobadoSinFormalizar += 1;
        } else if (subStatus === "rechazado") {
          acc[asesor].rechazadoSubstatus += 1;
          acc[asesor].rechazadosTotal += 1;
        }
      }

      if (esContado) {
        acc[asesor].totalContado += 1;

        // Status de contado
        if (status === "cotizacion") {
          acc[asesor].cotizacionContado += 1;
        } else if (status === "formalizado") {
          acc[asesor].formalizadoContado += 1;
          acc[asesor].formalizadosTotal += 1;
        }
      }

      if (esArrendamiento) {
        acc[asesor].totalArrendamiento += 1;

        // Status de arrendamiento
        if (status === "cotizacion") {
          acc[asesor].cotizacionArrendamiento += 1;
        } else if (status === "pendiente de autorizacion") {
          acc[asesor].pendienteAutorizacionArrendamiento += 1;
        } else if (status === "autorizado") {
          acc[asesor].autorizadoArrendamiento += 1;
        } else if (status === "rechazado") {
          acc[asesor].rechazadoArrendamiento += 1;
          acc[asesor].rechazadosTotal += 1;
        } else if (status === "formalizado") {
          acc[asesor].formalizadoArrendamiento += 1;
          acc[asesor].formalizadosTotal += 1;
        }
      }

      return acc;
    }, {});

    const datosProcesados = Object.values(agrupados);

    const mejores = datosProcesados
      .slice()
      .sort((a, b) => b.total - a.total)
      .slice(0, 6);

    return {
      datosProcesados,
      mejores,
    };
  };

  const fetchData = async () => {
    setLoading(true);

    try {
      // Todos los filtros se aplican en el servidor
      const { statusCode, resultados: resultadosApi } =
        await consultarSolicitudes(filters);

      if (statusCode === 200 && resultadosApi.length > 0) {
        const resultados = resultadosApi.map((cliente) => ({
          ...cliente,
          productos: obtenerProductos(cliente),
        }));

        const { datosProcesados, mejores } =
          generarRendimientoPorAsesor(resultados);

        setMailData(resultados);
        setProcessedData(datosProcesados);
        setTopCinco(mejores);
      } else {
        setMailData([]);
        setTopCinco([]);
        setProcessedData([]);

        Swal.fire({
          icon: "warning",
          title: "Sin resultados",
          text: "No se encontraron resultados para los filtros aplicados.",
        });
      }
    } catch (error) {
      console.error("Error al consultar rendimiento:", error);

      setMailData([]);
      setTopCinco([]);
      setProcessedData([]);

      Swal.fire({
        icon: "warning",
        title: "Sin resultados",
        text: "No se encontraron resultados para los filtros aplicados.",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [filters]);

  useEffect(() => {
    if ($.fn.DataTable.isDataTable("#datatableDefault")) {
      $("#datatableDefault").DataTable().destroy();
    }

    if (!loading && processedData.length > 0) {
      setTimeout(() => {
        if ($("#datatableDefault").length) {
          tableRef.current = $("#datatableDefault").DataTable({
            dom: "<'row mb-3'<'col-md-4'l><'col-md-8 text-right'<'d-lg-flex justify-content-end'fB>>>t<'row align-items-center mt-3'<'mr-auto col-md-6 mb-3 mb-md-0'i><'mb-0 col-md-6'p>>",
            lengthMenu: [10, 20, 30, 40, 50],
            responsive: false,
            scrollX: true,
            autoWidth: false,
            buttons: [
              {
                extend: "print",
                className: "btn btn-default btn-sm ms-2 mt-3 mt-md-0",
              },
              {
                extend: "csv",
                className: "btn btn-default btn-sm mt-3 mt-md-0",
              },
            ],
          });
        }
      }, 100);
    }

    return () => {
      if ($.fn.DataTable.isDataTable("#datatableDefault")) {
        $("#datatableDefault").DataTable().destroy();
      }
    };
  }, [processedData, loading]);

  useEffect(() => {
    const observer = new MutationObserver(() => {
      const cancelButton = document.querySelector(".cancelBtn");
      const applyButton = document.querySelector(".applyBtn");

      if (cancelButton && cancelButton.textContent !== "Cancelar") {
        cancelButton.textContent = "Cancelar";
      }

      if (applyButton && applyButton.textContent !== "Aplicar") {
        applyButton.textContent = "Aplicar";
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, []);


  return (
    <div>
      {loading ? (
        <div className="loader-data">
          <Circles height="80" width="80" color="#4fa94d" />
        </div>
      ) : (
        <div className="mailbox">
          <div className="mailbox-body" style={{ display: "block" }}>
            <div className="mailbox-content">
              <h1 className="page-header">
                Rendimiento <small>F&I, Asesores</small>
              </h1>

              <div className="row mb-5">
                <h4>Asesores</h4>

                {topCinco.map((asesor) => (
                  <div className="card col-md-2" key={asesor.nombre}>
                    <div className="card-header d-flex">{asesor.nombre}</div>

                    <div className="card-body">
                      <div className="row mb-2">
                        <div className="col-9 text-center">Total</div>
                        <div className="col-3 text-end">{asesor.total}</div>
                      </div>

                      <div className="row mb-2">
                        <div className="col-9 text-center">Crédito</div>
                        <div className="col-3 text-end">
                          {asesor.totalCredito}
                        </div>
                      </div>

                      <div className="row mb-2">
                        <div className="col-9 text-center">Contado</div>
                        <div className="col-3 text-end">
                          {asesor.totalContado}
                        </div>
                      </div>

                      <div className="row mb-2">
                        <div className="col-9 text-center">Arrendamiento</div>
                        <div className="col-3 text-end">
                          {asesor.totalArrendamiento}
                        </div>
                      </div>

                      <div className="row mb-2">
                        <div className="col-9 text-center">Autorizadas</div>
                        <div className="col-3 text-end">
                          {asesor.autorizado}
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-9 text-center">Formalizadas</div>
                        <div className="col-3 text-end">
                          {asesor.formalizadosTotal}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              <div>
                <BarraFiltrosSolicitudes
                  filters={filters}
                  onChange={setFilters}
                  opciones={opcionesFiltros}
                />

                <div>
                  <h4>F&I</h4>

                  <style>
                    {`
    .rendimiento-table th,
    .rendimiento-table td {
      white-space: nowrap;
      padding: 10px 14px !important;
      vertical-align: middle;
    }

    .rendimiento-table th:nth-child(1),
    .rendimiento-table td:nth-child(1) {
      min-width: 180px;
    }

    .rendimiento-table th:nth-child(2),
    .rendimiento-table td:nth-child(2) {
      min-width: 130px;
    }

    .rendimiento-table th:nth-child(3),
    .rendimiento-table td:nth-child(3) {
      min-width: 260px;
    }
  `}
                  </style>
                  <style>
                    {`
    .rendimiento-table th,
    .rendimiento-table td {
      white-space: nowrap;
      padding: 10px 18px !important;
      vertical-align: middle;
    }

    .rendimiento-table th {
      padding-right: 35px !important;
      position: relative;
    }

    table.dataTable thead > tr > th.sorting,
    table.dataTable thead > tr > th.sorting_asc,
    table.dataTable thead > tr > th.sorting_desc {
      padding-right: 35px !important;
    }

    table.dataTable thead > tr > th.sorting::before,
    table.dataTable thead > tr > th.sorting::after,
    table.dataTable thead > tr > th.sorting_asc::before,
    table.dataTable thead > tr > th.sorting_asc::after,
    table.dataTable thead > tr > th.sorting_desc::before,
    table.dataTable thead > tr > th.sorting_desc::after {
      right: 12px !important;
    }

    .rendimiento-table th:nth-child(1),
    .rendimiento-table td:nth-child(1) {
      min-width: 180px;
    }

    .rendimiento-table th:nth-child(2),
    .rendimiento-table td:nth-child(2) {
      min-width: 150px;
    }

    .rendimiento-table th:nth-child(3),
    .rendimiento-table td:nth-child(3) {
      min-width: 280px;
    }
  `}
                  </style>

                  {processedData.length > 0 ? (
                    <table
                      id="datatableDefault"
                      className="table table-bordered align-middle w-100 rendimiento-table"
                    >
                      <thead>
                        <tr>
                          <th>Asesor</th>
                          <th>Teléfono</th>
                          <th>Email</th>
                          <th>Total</th>

                          <th>Crédito</th>
                          <th>Contado</th>
                          <th>Arrendamiento</th>

                          <th>Autorizado</th>
                          <th>Rechazado Crédito</th>
                          <th>Pendiente Buró</th>

                          <th>Análisis</th>
                          <th>Incompleto</th>
                          <th>Cond. Viable</th>
                          <th>Cond. No Viable</th>
                          <th>Facturado</th>
                          <th>Formalizado Crédito</th>
                          <th>Aprobado Sin Formalizar</th>
                          <th>Rechazado Substatus</th>

                          <th>Cotización Contado</th>
                          <th>Formalizado Contado</th>

                          <th>Cotización Arrendamiento</th>
                          <th>Pendiente Autorización Arrendamiento</th>
                          <th>Autorizado Arrendamiento</th>
                          <th>Rechazado Arrendamiento</th>
                          <th>Formalizado Arrendamiento</th>

                          <th>Total Formalizados</th>
                          <th>Total Rechazados</th>
                        </tr>
                      </thead>

                      <tbody id="datatableDefaultBody">
                        {processedData.map((cliente) => (
                          <tr key={cliente.nombre}>
                            <td>{cliente.nombre || "Sin nombre"}</td>
                            <td>{cliente.telefono || "N/A"}</td>
                            <td>{cliente.correo_electronico || "N/A"}</td>
                            <td>{cliente.total || 0}</td>

                            <td>{cliente.totalCredito || 0}</td>
                            <td>{cliente.totalContado || 0}</td>
                            <td>{cliente.totalArrendamiento || 0}</td>

                            <td>{cliente.autorizado || 0}</td>
                            <td>{cliente.rechazadoCredito || 0}</td>
                            <td>{cliente.pendienteBuro || 0}</td>

                            <td>{cliente.analisis || 0}</td>
                            <td>{cliente.incompleto || 0}</td>
                            <td>{cliente.condicionadoViable || 0}</td>
                            <td>{cliente.condicionadoNoViable || 0}</td>
                            <td>{cliente.facturado || 0}</td>
                            <td>{cliente.formalizadoCredito || 0}</td>
                            <td>{cliente.aprobadoSinFormalizar || 0}</td>
                            <td>{cliente.rechazadoSubstatus || 0}</td>

                            <td>{cliente.cotizacionContado || 0}</td>
                            <td>{cliente.formalizadoContado || 0}</td>

                            <td>{cliente.cotizacionArrendamiento || 0}</td>
                            <td>
                              {cliente.pendienteAutorizacionArrendamiento || 0}
                            </td>
                            <td>{cliente.autorizadoArrendamiento || 0}</td>
                            <td>{cliente.rechazadoArrendamiento || 0}</td>
                            <td>{cliente.formalizadoArrendamiento || 0}</td>

                            <td>{cliente.formalizadosTotal || 0}</td>
                            <td>{cliente.rechazadosTotal || 0}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    <div
                      className="mailbox-detail-placeholder"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100%",
                        textAlign: "center",
                      }}
                    >
                      No hay datos disponibles para mostrar
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Rendimiento;